// Per-kind UI registry for the storages-strategies framework.
//
// cortex is a storages-strategies framework: typed storages connected by typed
// strategies. Each strategy KIND can ship its own config panel. A kind module
// (components/strategies/<kind>/index.jsx) calls registerStrategyKind() at import
// time; the barrel (./index.js) imports all kind modules so they self-register.
//
// The Strategies pages resolve a kind's `ui_component` (from /api/strategy_kinds)
// to its registered Panel. A kind with no registered Panel renders a graceful
// "panel not installed" fallback — so a new kind can be added (registry row +
// Flow endpoint) without a frontend deploy.

const REGISTRY = {};

export function registerStrategyKind(kind, { label, Panel, NavChildren } = {}) {
  REGISTRY[kind] = { kind, label: label || kind, Panel: Panel || null, NavChildren: NavChildren || null };
}

export function getStrategyKind(kind) {
  return REGISTRY[kind] || null;
}

export function allStrategyKinds() {
  return Object.values(REGISTRY);
}
